// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { engineApi } from '@shared/data-access/api-base/citec-engine-api';
import type {
  VoucherCode,
  SubscriptionsResp,
} from '@shared/data-access/interfaces/api/engine/subscriptions';

export const subscriptionsApi = engineApi.injectEndpoints({
  endpoints: build => ({
    getSubscription: build.query<SubscriptionsResp, void>({
      query: () => ({
        url: '/subscriptions/subscription/',
        method: 'GET',
      }),
      providesTags: [{ type: 'Subscription', id: 'Subscription' }],
    }),

    activateTrial: build.query<SubscriptionsResp, void>({
      query: () => ({
        url: '/subscriptions/trial/',
        method: 'POST',
      }),
      providesTags: [{ type: 'Subscription', id: 'Trial' }],
    }),

    activateVoucher: build.query<SubscriptionsResp, VoucherCode>({
      query: params => ({
        url: '/subscriptions/voucher/',
        method: 'POST',
        params,
      }),
      extraOptions: {
        useTrackPromise: true,
      },
      providesTags: [{ type: 'Subscription', id: 'Voucher' }],
    }),
  }),
});
